/**
 * Under a finished Reel: the host's photos the clip was filmed from, best first, as the same
 * small tiles the three steps use. Nothing when the clip came from words alone or the photos
 * have since left the library.
 */
import type { MediaDto } from '@str/api/types';
import { mediaStyle } from '@/lib/scenes';

type Photo = Pick<MediaDto, 'id' | 'label' | 'url' | 'scene'>;

export function FilmedFrom({ ids, library }: { ids: string[]; library: Photo[] }) {
  const photos = ids.flatMap((id) => library.find((m) => m.id === id) ?? []);
  if (!photos.length) return null;
  return (
    <div className="nx-filmed">
      <span className="label-caps">Filmed from these photos</span>
      <div className="nx-wiz-chosen">
        {photos.map((m) => (
          <span
            key={m.id}
            role="img"
            aria-label={m.label}
            title={m.label}
            className="pic"
            style={mediaStyle(m)}
          />
        ))}
      </div>
    </div>
  );
}
